<style lang="less" scoped>
@import '../../../style/common/variable';
.searchBar {position: relative;
ul {display: flex;list-style: none;width: 1200px;}
li {float: left;margin-right: 21px;font-size: 14px;}
.input {width: 264px !important;font-family: MicrosoftYaHei;font-size: 14px !important;}
.el-select {width: 264px !important;font-family: MicrosoftYaHei;}
.button {width: 40px !important;height: 40px !important;cursor: pointer;font-size: 24px;background-color: white;border: solid rgb(219, 216, 216);border-width: 1px;border-radius: 5px;}}
.button:hover{color:#13569e;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .searchBar {
    ul{display: flex;flex-direction: column;width: 100vw;
      li{margin-top: .1rem}
    }
  }
}
</style>

<template>
  <div class="searchBar">
    <ul>
      <li>
        <el-input class="input" v-model="input" placeholder="请输入关键词"></el-input>
      </li>
      <li>
        <el-select v-model="FenLei" placeholder="不限分类" :clearable="true">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="TuiJian" placeholder="推荐方式" :clearable="true">
          <el-option v-for="item in options2" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="GuoJia" placeholder="国家" :clearable="true">
          <el-option v-for="item in options3" :key="item.id" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </li>
      <li>
        <button class="button" @click="search({keyword: input,catid: FenLei,sort: TuiJian,ssgj: GuoJia})"><i class="el-icon-search"></i></button>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 2021.7.1
 * 搜索栏：一个input框、三个select框、一个搜索按钮，根据设置的条件搜索数据
 */
export default {
  data()
  {
    return {
      input: '', // 输入的关键词
      options1: [
        { id: '选项1', name: '地质矿产', value: 99 },
        { id: '选项2', name: '矿业技术', value: 102 },
        { id: '选项3', name: '投资环境', value: 101 },
        { id: '选项4', name: '政策法规', value: 100 }
      ],
      FenLei: '', // 被选中的分类方式
      options2: [
        { id: '选项1', name: '按阅读量排序方式', value: 'hits DESC' },
        { id: '选项2', name: '按最新发布时间',   value: 'addtime DESC' }
      ],
      TuiJian: '', // 选中的推荐方式,默认为按最新发布时间
      options3: [
        { id: '选项1',  name: '中国',      value: 2 },
        { id: '选项2',  name: '印度尼西亚', value: 3 },
        { id: '选项3',  name: '马来西亚',   value: 4 },
        { id: '选项4',  name: '菲律宾',     value: 5 },
        { id: '选项5',  name: '新加坡',     value: 6 },
        { id: '选项6',  name: '泰国',       value: 7 },
        { id: '选项7',  name: '文莱',       value: 8 },
        { id: '选项8',  name: '越南',       value: 9 },
        { id: '选项9', name: '老挝',       value: 10 },
        { id: '选项10', name: '缅甸',       value: 11 },
        { id: '选项11', name: '柬埔寨',     value: 12 },
        { id: '选项12', name: '其他',       value: 13 }
      ],
      GuoJia: '' // 被选中的国家
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.input = nval.query.keyword // 输入关键字
        // 分类方式
        switch (+nval.query.catid)
        {
        case 0 : this.FenLei = ''
          break
        case 99 : this.FenLei = '地质矿产'
          break
        case 102 : this.FenLei = '矿业技术'
          break
        case 101 : this.FenLei = '投资环境'
          break
        case 100 : this.FenLei = '政策法规'
          break
        }
        this.TuiJian = nval.query.sort // 推荐方式
        // 国家
        switch (+nval.query.ssgj)
        {
        case 0 : this.GuoJia = ''
          break
        case 2 : this.GuoJia = '中国'
          break
        case 3 : this.GuoJia = '印度尼西亚'
          break
        case 4 : this.GuoJia = '马来西亚'
          break
        case 5 : this.GuoJia = '菲律宾'
          break
        case 6 : this.GuoJia = '新加坡'
          break
        case 7 : this.GuoJia = '泰国'
          break
        case 8 : this.GuoJia = '文莱'
          break
        case 9 : this.GuoJia = '越南'
          break
        case 10 : this.GuoJia = '老挝'
          break
        case 11 : this.GuoJia = '缅甸'
          break
        case 12 : this.GuoJia = '柬埔寨'
          break
        }
      },
      immediate: true
    }
  },
  methods: {
    search(obj)
    {
      switch (obj.catid)
      {
      case '' : obj.catid = 0
        break
      case '地质矿产' : obj.catid = 99
        break
      case '矿业技术' : obj.catid = 102
        break
      case '投资环境' : obj.catid = 101
        break
      case '政策法规' : obj.catid = 100
        break
      }
      switch (obj.ssgj)
      {
      case '' : obj.ssgj = 0
        break
      case '中国' : obj.ssgj = 2
        break
      case '印度尼西亚' : obj.ssgj = 3
        break
      case '马来西亚' : obj.ssgj = 4
        break
      case '菲律宾' : obj.ssgj = 5
        break
      case '新加坡' : obj.ssgj = 6
        break
      case '泰国' : obj.ssgj = 7
        break
      case '文莱' : obj.ssgj = 8
        break
      case '越南' : obj.ssgj = 9
        break
      case '老挝' : obj.ssgj = 10
        break
      case '缅甸' : obj.ssgj = 11
        break
      case '柬埔寨' : obj.ssgj = 12
        break
      }
      let url = this.$router.resolve({path: '/ZlkKeywords', query: obj})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SearchBar.vue